// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__YWHGX","imageContainer":"Card_imageContainer__xQXyv","addBtn":"Card_addBtn__HQblx","itemName":"Card_itemName__IH28Z"};